import crypto from "crypto";
import { OAUTH_SCOPE } from "../constants/urls";
import { RegistrationUrlParams } from "@models/auth";
import { getConfig } from "config";
import { signIn, signOut } from "next-auth/react";

const { IDENTITY_BASE_URL, HOST } = getConfig();

const base64URLEncode = (buffer: Buffer) => {
	return buffer
		.toString("base64")
		.replace(/\+/g, "-")
		.replace(/\//g, "_")
		.replace(/=/g, "");
};

const sha256 = (value: string) => {
	return crypto.createHash("sha256").update(value).digest();
};

export const generateCodeVerifier = () => base64URLEncode(crypto.randomBytes(32));

export const generateCodeChallenge = (verifier: string) =>
	base64URLEncode(sha256(verifier));

export const getRegistrationUrl = ({
	clientId,
	redirectUri,
	codeChallenge,
	authServerUrl,
}: RegistrationUrlParams) => {
	const params = {
		client_id: clientId,
		redirect_uri: redirectUri,
		response_type: "code",
		code_challenge: codeChallenge,
		code_challenge_method: "S256",
		scope: OAUTH_SCOPE,
	};

	const urlParams = new URLSearchParams(params);
	return `${authServerUrl}?${urlParams.toString()}`;
};

export const login = async (redirectPath: string) => {
	return await signIn("beatport", {
		callbackUrl: `${HOST}${redirectPath}`,
	});
};

export const logout = async () => {
	try {
		return await signOut({ redirect: false }); // Clear local NextAuth session
	} finally {
		// Ensure logout from IDS
		// Some browsers (like Safari/Firefox) block third-party cookies,
		// so this step is needed to fully clear the SSO session
		window.location.href = `${IDENTITY_BASE_URL}/identity/v1/logout/?callbackUrl=${HOST}`;
	}
};
